import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import { Tooltip } from "antd";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";

export const Columns = (
  onClick: (e: any) => void,
  setRepresentanteId: (e: any) => void,
  setUsuarioId: (e: any) => void
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
    },
    {
      title: "Data inclusão",
      dataIndex: "dataInclusao",
      key: "dataInclusa",
      width: "30%",
    },

    {
      title: "Data Assinatura",
      dataIndex: "dataAssinatura",
      key: "dataAssinatura",
      width: "30%",
    },

    {
      title: "Data Vencimento",
      dataIndex: "dataVencimento",
      key: "dataVencimento",
      width: "30%",
    },
    {
      title: "Situaçao",
      dataIndex: "situacao",
      key: "situacao",
      width: "30%",
      render: (item, row) =>
        row.situacao === "Sim" ? (
          <Tooltip title="Válido">
            <VerifiedIcon color="success" />
          </Tooltip>
        ) : row.situacao === "Nao" ? (
          <Tooltip title="Não válido">
            <CancelIcon color="error" />
          </Tooltip>
        ) : null,
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setRepresentanteId(row.id);
                setUsuarioId(row.usuarioId);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
